__turbopack_context__.v({
  "SCompButton": "_9HbDza_SCompButton",
  "SCompCheckbox": "_9HbDza_SCompCheckbox",
  "SCompForm": "_9HbDza_SCompForm",
  "SCompInputText": "_9HbDza_SCompInputText",
  "SCompLabel": "_9HbDza_SCompLabel",
  "SCompLabelWithInput": "_9HbDza_SCompLabelWithInput",
  "SCompLink": "_9HbDza_SCompLink",
  "SCompOneInput": "_9HbDza_SCompOneInput",
  "SCompRadioButton": "_9HbDza_SCompRadioButton",
});
